import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { Box, SxProps, Theme } from '@mui/material';
import { darken, lighten } from '@mui/material/styles';
import React from 'react';

import { US_ADDRESSES_ONLY_LABEL } from '../../../constants/marketplace';
import { PILL_BORDER_RADIUS } from '../../../constants/ui';

const pillSx: SxProps<Theme> = {
  flexShrink: 0,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  height: 24,
  boxSizing: 'border-box',
  pl: 0.75,
  pr: 1.25,
  borderRadius: PILL_BORDER_RADIUS,
  backgroundColor: ({ palette }) => lighten(palette.warning.light, 0.88),
  color: ({ palette }) => darken(palette.warning.main, 0.35),
  typography: 'body2',
  fontSize: 13,
  fontWeight: 'medium',
  lineHeight: '24px',
  whiteSpace: 'nowrap',
};

const iconSx: SxProps<Theme> = { fontSize: 16, color: 'warning.main' };

export const UsOnlyPill: React.FC = () => (
  <Box component="span" sx={pillSx}>
    <PublicOutlinedIcon aria-hidden sx={iconSx} />
    {US_ADDRESSES_ONLY_LABEL}
  </Box>
);
